export default __webpack_public_path__ + "locales/uk-UA/Webhooks.json?hash=482ec29c9ce3c98c2630c4e20f2d9d56";